import { render } from "./Collections-page.vue?vue&type=template&id=d80e60e6&scoped=true"
import script from "./Collections-page.vue?vue&type=script&lang=js"
export * from "./Collections-page.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=d80e60e6&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d80e60e6"]])

export default __exports__